import authCz from "./authCz";
import commonCz from "./commonCz";
import footerCz from "./footerCz";
import galleryCz from "./galleryCz";
import menuCz from "./menuCz";
import navigationCz from "./navigationCz";
import orderCz from "./orderCz";
import paymentCz from "./paymentCz";
import statisticsCz from "./statisticsCz";

const mainCz = {
    common: commonCz,
    navigation: navigationCz,
    menu: menuCz,
    statistics: statisticsCz,
    order: orderCz,
    payment: paymentCz,
    auth: authCz,
    gallery: galleryCz,
    footer: footerCz,
};

export default mainCz;
